import React, { useState } from 'react';

const SelectorModal = ({ type, initialValue, options, friends, onSelect, onClose, payerName, onDeleteFriend, selectedIds = [], onToggleFriend, titleOverride }) => {
    const [searchTerm, setSearchTerm] = useState(type === 'split' ? '' : (initialValue === payerName ? '' : (initialValue || '')));

    const filterFriend = (f) => {
        const matchesSearch = f.display_name.toLowerCase().includes(searchTerm.toLowerCase()) || 
                              (f.username && f.username.toLowerCase().includes(searchTerm.toLowerCase()));
        const notPayer = !payerName || f.display_name !== payerName;
        return matchesSearch && notPayer;
    };

    const filterSaved = (p) => {
        const matchesSearch = p.name.toLowerCase().includes(searchTerm.toLowerCase());
        const notPayer = !payerName || p.name !== payerName;
        return matchesSearch && notPayer;
    };

    const getTitle = () => {
        if (titleOverride) return titleOverride;
        if (type === 'split') return 'เลือกสัดส่วน';
        if (type === 'share') return 'เลือกเพื่อนที่จะแชร์';
        return 'เลือกคนจ่าย';
    };

    return (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 2000, display: 'flex', alignItems: 'flex-end' }} onClick={onClose}>
            <div style={{ backgroundColor: '#fff', width: '100%', borderRadius: '20px 20px 0 0', padding: '20px', height: '90vh', overflowY: 'auto', animation: 'slideUp 0.3s ease-out' }} onClick={e => e.stopPropagation()}>
                <style>
                    {`@keyframes slideUp { from { transform: translateY(100%); } to { transform: translateY(0); } }`}
                </style>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                    <h3 style={{ margin: 0, fontSize: '18px', color: 'var(--color-text)' }}>{getTitle()}</h3>
                    <button onClick={onClose} style={{ border: 'none', background: 'none', fontSize: '24px', color: 'var(--color-text-subtle)', cursor: 'pointer' }}>&times;</button>
                </div>

                {type === 'split' ? (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                        <button onClick={() => onSelect('none')} style={{ padding: '15px', borderRadius: '12px', border: initialValue === 'none' ? '2px solid var(--color-primary)' : '1px solid var(--color-border)', backgroundColor: initialValue === 'none' ? 'var(--color-primary-soft)' : '#fff', color: initialValue === 'none' ? 'var(--color-primary)' : 'var(--color-text)', fontWeight: 'bold', textAlign: 'left', fontSize: '16px' }}>
                            ไม่เรียก (จ่ายเอง)
                        </button>
                        <button onClick={() => onSelect('half')} style={{ padding: '15px', borderRadius: '12px', border: initialValue === 'half' ? '2px solid var(--color-primary)' : '1px solid var(--color-border)', backgroundColor: initialValue === 'half' ? 'var(--color-primary-soft)' : '#fff', color: initialValue === 'half' ? 'var(--color-primary)' : 'var(--color-text)', fontWeight: 'bold', textAlign: 'left', fontSize: '16px' }}>
                            หารเท่า (50/50)
                        </button>
                        <button onClick={() => onSelect('full')} style={{ padding: '15px', borderRadius: '12px', border: initialValue === 'full' ? '2px solid var(--color-primary)' : '1px solid var(--color-border)', backgroundColor: initialValue === 'full' ? 'var(--color-primary-soft)' : '#fff', color: initialValue === 'full' ? 'var(--color-primary)' : 'var(--color-text)', fontWeight: 'bold', textAlign: 'left', fontSize: '16px' }}>
                            เก็บเต็มจำนวน (100%)
                        </button>
                    </div>
                ) : type === 'share' ? (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                        <input 
                            type="text" 
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            placeholder="ค้นหาเพื่อน..." 
                            style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid var(--color-border)', fontSize: '16px', boxSizing: 'border-box' }}
                        />

                        {friends && friends.filter(filterFriend).map(f => {
                            const isSelected = selectedIds.map(id => String(id)).includes(String(f.id));
                            return (
                                <button
                                    key={f.id}
                                    onClick={() => onToggleFriend && onToggleFriend(f)}
                                    style={{
                                        padding: '15px',
                                        borderRadius: '12px',
                                        border: isSelected ? '2px solid var(--color-primary)' : '1px solid var(--color-border)',
                                        backgroundColor: isSelected ? 'var(--color-primary-soft)' : '#fff',
                                        textAlign: 'left',
                                        fontSize: '16px',
                                        color: isSelected ? 'var(--color-primary)' : 'var(--color-text)',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '10px',
                                        fontWeight: isSelected ? 'bold' : 'normal',
                                        cursor: 'pointer'
                                    }}
                                >
                                    {f.picture_url ? <img src={f.picture_url} alt="" style={{ width: '30px', height: '30px', borderRadius: '50%' }} /> : <div style={{ width: '30px', height: '30px', borderRadius: '50%', backgroundColor: 'var(--color-border)' }}></div>}
                                    <div>
                                        <div>{f.display_name || 'Unknown'}</div>
                                        <div style={{ fontSize: '12px', color: 'var(--color-text-subtle)' }}>@{f.username}</div>
                                    </div>
                                </button>
                            );
                        })}
                    </div>
                ) : (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                        <input 
                            type="text" 
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            placeholder="ค้นหาชื่อเพื่อน, เพิ่มใหม่..." 
                            style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid var(--color-border)', fontSize: '16px', boxSizing: 'border-box' }}
                        />

                        {/* Manual Add Option */}
                        {searchTerm.trim() && (
                            <button 
                                onClick={() => onSelect(searchTerm.trim())}
                                style={{ padding: '15px', borderRadius: '12px', border: '1px dashed var(--color-primary)', backgroundColor: 'var(--color-primary-soft)', color: 'var(--color-primary)', fontWeight: 'bold', textAlign: 'left', fontSize: '16px' }}
                            >
                                + ใช้ชื่อ "{searchTerm}" (ไม่ระบุตัวตน)
                            </button>
                        )}
                        
                        {/* ถ้าคนจ่ายไม่ใช่ "ฉัน" ให้แสดงตัวเลือก "ฉัน" (เพื่อบอกว่าฉันติดหนี้เขา) */}
                        {payerName && payerName !== 'ฉัน' && 'ฉัน'.includes(searchTerm) && (
                            <button onClick={() => onSelect('ฉัน')} style={{ padding: '15px', borderRadius: '12px', border: initialValue === 'ฉัน' ? '2px solid var(--color-primary)' : '1px solid var(--color-border)', backgroundColor: initialValue === 'ฉัน' ? 'var(--color-primary-soft)' : '#fff', textAlign: 'left', fontSize: '16px', color: initialValue === 'ฉัน' ? 'var(--color-primary)' : 'var(--color-text)', fontWeight: initialValue === 'ฉัน' ? 'bold' : 'normal' }}>
                                ฉัน
                            </button>
                        )}

                        {/* Friends */}
                        {friends && friends.filter(filterFriend).map(f => (
                            <div key={f.id} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <button onClick={() => onSelect(f.display_name, f)} style={{ flex: 1, padding: '15px', borderRadius: '12px', border: initialValue === f.display_name ? '2px solid var(--color-primary)' : '1px solid var(--color-border)', backgroundColor: initialValue === f.display_name ? 'var(--color-primary-soft)' : '#fff', textAlign: 'left', fontSize: '16px', color: initialValue === f.display_name ? 'var(--color-primary)' : 'var(--color-text)', display: 'flex', alignItems: 'center', gap: '10px', fontWeight: initialValue === f.display_name ? 'bold' : 'normal' }}>
                                    {f.picture_url ? <img src={f.picture_url} alt="" style={{ width: '30px', height: '30px', borderRadius: '50%' }} /> : <div style={{ width: '30px', height: '30px', borderRadius: '50%', backgroundColor: 'var(--color-border)' }}></div>}
                                    <div>
                                        <div>{f.display_name || 'Unknown'}</div>
                                        <div style={{ fontSize: '12px', color: 'var(--color-text-subtle)' }}>@{f.username}</div>
                                    </div>
                                </button>
                                {onDeleteFriend && (
                                    <button onClick={(e) => { e.stopPropagation(); onDeleteFriend(f.id); }} style={{ padding: '15px', borderRadius: '12px', border: '1px solid var(--color-border)', backgroundColor: '#fff', color: '#f44336', cursor: 'pointer' }}>
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>
                                    </button>
                                )}
                            </div>
                        ))}
                        
                        {/* Saved Payers */}
                        {options.filter(filterSaved).map(p => (
                            <button key={p.id} onClick={() => onSelect(p.name)} style={{ padding: '15px', borderRadius: '12px', border: initialValue === p.name ? '2px solid var(--color-primary)' : '1px solid var(--color-border)', backgroundColor: initialValue === p.name ? 'var(--color-primary-soft)' : '#fff', textAlign: 'left', fontSize: '16px', color: initialValue === p.name ? 'var(--color-primary)' : 'var(--color-text)', fontWeight: initialValue === p.name ? 'bold' : 'normal' }}>
                                {p.name} <span style={{ fontSize: '12px', color: 'var(--color-text-subtle)' }}>(รายชื่อเดิม)</span>
                            </button>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default SelectorModal;
